<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M13.3337 4L6.00032 11.3333L2.66699 8" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>





<script>
export default {
  name: 'IconCheck',
  props: {
    color: {
      type: String,
      required: false,
      default: '#757575',
    }
  },

};
</script>
